import { render, staticRenderFns } from "./WrapperCard.vue?vue&type=template&id=4a5e6b40"
import script from "./WrapperCard.vue?vue&type=script&lang=js"
export * from "./WrapperCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports